// Copyright (c) Bentley Systems
import * as React from "react";
import { useEffect, useState } from "react";
import { LabeledSelect, SelectOption } from "@itwin/itwinui-react";

type CustomLabeledSelectProps = {
  label: string;
  options: SelectOption<string>[];
  onChange: (value: string) => void;
  value: string;
};

const CustomLabeledSelect: React.FC<CustomLabeledSelectProps> = (
  props: CustomLabeledSelectProps,
) => {
  const [selectedValue, setSelectedValue] = useState(props.value);

  useEffect(() => {
    setSelectedValue(props.value);
  }, [props.value]);

  return (
    <LabeledSelect
      label={props.label}
      options={props.options}
      onChange={(selected: string) => {
        setSelectedValue(selected);
        props.onChange(selected);
      }}
      value={selectedValue}
    />
  );
};

export default CustomLabeledSelect;
